import { render, staticRenderFns } from "./DatingReviewInfoPage.vue?vue&type=template&id=99a74f98&scoped=true"
import script from "./DatingReviewInfoPage.vue?vue&type=script&lang=js"
export * from "./DatingReviewInfoPage.vue?vue&type=script&lang=js"
import style0 from "./DatingReviewInfoPage.vue?vue&type=style&index=0&id=99a74f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a74f98",
  null
  
)

export default component.exports